// extracted by mini-css-extract-plugin
export default {"wrapper":"VoucherPage_wrapper__eYNF+"};